import type { ReactNode } from 'react'
import { MaintenanceScreen } from '@klear/ui/components/maintenance-screen'
import { UpdateRequiredScreen } from '@klear/ui/components/update-required-screen'

type AppGateProps = {
  isMaintenance: boolean
  isStale: boolean
  logoSrc?: string
  children: ReactNode
}

export function AppGate({ isMaintenance, isStale, logoSrc, children }: AppGateProps) {
  if (isMaintenance) return <MaintenanceScreen logoSrc={logoSrc} />
  if (isStale) return <UpdateRequiredScreen logoSrc={logoSrc} />
  return <>{children}</>
}
